import { Box } from '@mui/material'
import React from 'react'
import { connect } from 'react-redux'
import {
  Operations as ThemeOperations,
  operations as themeOperations
} from 'states/dux/theme/operations'
import { Payload as ThemePayload } from 'states/dux/theme/types'
import State from 'states/types'
import { mapOperationsToDispatchProps } from 'utils/common'

interface StateProps {
  theme: ThemePayload
}

interface DispatchProps {
  operations: {
    theme: ThemeOperations
  }
}

type AppProps = StateProps & DispatchProps

const NivosFooterFC: React.FC<any> = (props: AppProps) => {
  const { theme } = props
  console.log(theme)
  return <Box />
}

const mapStateToProps = (state: State): StateProps => {
  return {
    theme: state.theme
  }
}

const mapDispatchToProps = mapOperationsToDispatchProps({
  theme: themeOperations
})

const NivosFooter = connect(mapStateToProps, mapDispatchToProps)(NivosFooterFC)

export default NivosFooter
